import {
    Background,
    BackgroundImage,
    ImageContent,
    TextContainer,
    LeftContainer,
    RightContainer,
    FloatingSquareImage,
} from '../components/welcome'
import blueBG from '../assets/images/fineline-welcome.jpg'
import orangeLine from '../assets/images/orange-line1.png'
import orangeBox from '../assets/images/orange-box1.png'
import { SubHeader32, SubHeader20, Header40, Header64, Paragraph18, SubHeader16 } from '../styles/typography'
import { OrangeButton, WhiteButton } from '../components/atoms/button'
import { HeaderLink } from '../components/atoms/link'

export function Welcome() {
    return (
        <>
            <Background>
                <BackgroundImage src={blueBG} />
                <FloatingSquareImage src={orangeBox} />
                <ImageContent>
                    <TextContainer>
                        <LeftContainer>
                            <div style={{ display: 'flex', flexDirection: 'row', gap: '12px', alignItems: 'center' }}>
                                <img style={{ height: '4px', width: '40px' }} src={orangeLine} />
                                <SubHeader32 style={{ color: '#FFBC5D' }}>Welcome To</SubHeader32>
                            </div>

                            <h2 style={{ color: '#FFF' }}>JB FINE LINE</h2>
                            <h2 style={{ color: '#FFF' }}>CONSTRUCTION</h2>
                        </LeftContainer>
                        <RightContainer>
                            <SubHeader16 style={{ textAlign: 'justify' }}>
                                We’re dedicated to building homes with craftsmanship, clarity, and care. Every project
                                reflects our commitment to quality construction and a client-first experience.
                            </SubHeader16>
                            <HeaderLink to='/about'>
                                <WhiteButton style={{ width: '200px' }}>
                                    <Paragraph18>About Us</Paragraph18>
                                </WhiteButton>
                            </HeaderLink>
                        </RightContainer>
                    </TextContainer>
                </ImageContent>
            </Background>
        </>
    )
}
